import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, createSlots as _createSlots, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "selectorComponent" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_4 = {
  key: 0,
  class: "popupMain"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "selectorTable" }
const _hoisted_7 = { class: "topSearch" }
const _hoisted_8 = { class: "tableTit" }
const _hoisted_9 = { class: "tit" }
const _hoisted_10 = { class: "tableBtn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 搜索 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_13 = {
  key: 0,
  class: "treeView"
}
const _hoisted_14 = { class: "group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "菜单权限", -1)
const _hoisted_16 = { class: "setInput" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("展开/折叠")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("全选/全不选")
const _hoisted_20 = { class: "tree" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"color":"#f50"} }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 1,
  class: "tableView"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "pagination"
}

export function render(_ctx: any,_cache: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_alpIcon = _resolveComponent("alpIcon")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_JsxTemp = _resolveComponent("JsxTemp")!
  const _component_alpFormGroup = _resolveComponent("alpFormGroup")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: _ctx.isShow,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isShow) = $event)),
      title: _ctx.modalConfig.popupTitle || '请选择',
      centered: true,
      width: _ctx.modalConfig.width,
      class: "selectorModulePopup",
      closable: false,
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.modalConfig.showList)
                ? (_openBlock(), _createElementBlock("div", {
                    class: "topSelectList",
                    key: _ctx.tabelKey
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popupConfig.selData, (item) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "selectItem",
                        key: item[_ctx.modalConfig.majorKey]
                      }, [
                        _createTextVNode(_toDisplayString(item[_ctx.modalConfig.majorName]) + " ", 1),
                        _createElementVNode("b", {
                          class: "closeBtn",
                          onClick: _withModifiers(($event: any) => (_ctx.itemOptions('popupRemove', item)), ["stop"])
                        }, [
                          _createVNode(_component_CloseOutlined)
                        ], 8, _hoisted_5)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["shrinkBtn", { shrink: _ctx.popupConfig.topSearchFormShrink }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.topFormShrink()))
                      }, [
                        _createVNode(_component_alpIcon, {
                          size: 16,
                          type: "svg",
                          icon: "miscChevronUpDouble24.svg"
                        })
                      ], 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.modalConfig.formTitle || "请选择"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.topFunction.topOperate('search')))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_SearchOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        size: "small",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.topFunction.topOperate('reset')))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_SyncOutlined)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalConfig.topBtnList, (item, index) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          key: index,
                          size: "small",
                          disabled: 
                    item.hasOwnProperty('disabled')
                      ? item.disabled(_ctx.popupConfig.selectedData)
                      : false
                  ,
                          onClick: ($event: any) => (_ctx.topFunction.topOperate(item.key))
                        }, {
                          default: _withCtx(() => [
                            (item.icon)
                              ? (_openBlock(), _createBlock(_component_JsxTemp, {
                                  key: 0,
                                  icon: item.icon
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_vShow, 
                    item.hasOwnProperty('noShow')
                      ? !item.noShow(_ctx.popupConfig.selectedData)
                      : true
                  ]
                        ])
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["topSearchForm", { shrink: _ctx.popupConfig.topSearchFormShrink }])
                  }, [
                    _createVNode(_component_alpFormGroup, {
                      ref: "topSearchForm",
                      options: _ctx.modalConfig.topForm,
                      form_data: _ctx.popupConfig.topSearchFormData,
                      key: _ctx.tabelKey,
                      getDict: _ctx.$dict
                    }, _createSlots({ _: 2 }, [
                      _renderList(_ctx.slot.modal, (item, index) => {
                        return {
                          name: item.soltName,
                          fn: _withCtx(() => [
                            (item.soltName)
                              ? _renderSlot(_ctx.$slots, item.soltName, { key: 0 })
                              : _createCommentVNode("", true)
                          ])
                        }
                      })
                    ]), 1032, ["options", "form_data", "getDict"])
                  ], 2)
                ]),
                (_ctx.modalConfig.model == 'tree')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_a_checkbox, {
                              size: "small",
                              checked: _ctx.popupConfig.fold,
                              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.popupConfig.fold) = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.controlChange('fold')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }, 8, ["checked"]),
                            (_ctx.modalConfig.selectedType !== 'radio')
                              ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                  key: 0,
                                  size: "small",
                                  checked: _ctx.popupConfig.selAll,
                                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popupConfig.selAll) = $event)),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.controlChange('selAll')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_19
                                  ]),
                                  _: 1
                                }, 8, ["checked"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_tree, {
                              blockNode: true,
                              showLine: true,
                              size: "small",
                              checkable: "",
                              treeData: _ctx.popupConfig.deptTreeData,
                              checkStrictly: true,
                              expandedKeys: _ctx.popupConfig.deptExpandedKeys,
                              "onUpdate:expandedKeys": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.popupConfig.deptExpandedKeys) = $event)),
                              checkedKeys: _ctx.popupConfig.deptCheckedKeys,
                              "onUpdate:checkedKeys": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.popupConfig.deptCheckedKeys) = $event)),
                              replaceFields: _ctx.modalConfig.replaceFields,
                              onCheck: _ctx.treeCheck
                            }, {
                              title: _withCtx((scope) => [
                                (
                          scope[_ctx.modalConfig.majorName].indexOf(
                            _ctx.popupConfig.searchTreeKey
                          ) > -1
                        )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      _createTextVNode(_toDisplayString(scope[_ctx.modalConfig.majorName].substr(
                            0,
                            scope[_ctx.modalConfig.majorName].indexOf(
                              _ctx.popupConfig.searchTreeKey
                            )
                          )) + " ", 1),
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.popupConfig.searchTreeKey), 1),
                                      _createTextVNode(" " + _toDisplayString(scope[_ctx.modalConfig.majorName].substr(
                            scope[_ctx.modalConfig.majorName].indexOf(
                              _ctx.popupConfig.searchTreeKey
                            ) + _ctx.popupConfig.searchTreeKey.length
                          )), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope[_ctx.name]), 1))
                              ]),
                              _: 1
                            }, 8, ["treeData", "expandedKeys", "checkedKeys", "replaceFields", "onCheck"])
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", {
                        class: "table",
                        style: _normalizeStyle({ height: _ctx.popupConfig.tableViewHeight + 'px' })
                      }, [
                        _createVNode(_component_a_table, {
                          rowSelection: _ctx.rowSelection,
                          columns: _ctx.modalConfig.columns,
                          "data-source": _ctx.modalConfig.tableData,
                          rowKey: _ctx.modalConfig.majorKey,
                          pagination: false,
                          size: "small",
                          scroll: { y: _ctx.popupConfig.tableViewHeight - 40 },
                          bordered: "",
                          customRow: _ctx.tableFunction.customRow,
                          key: _ctx.tabelKey
                        }, _createSlots({ _: 2 }, [
                          _renderList(_ctx.tableColumns, (col) => {
                            return {
                              name: col.key,
                              fn: _withCtx(({ record, index }) => [
                                (
                      col.type === 'select' &&
                      _ctx.optionsObj.hasOwnProperty([col.key + 'map'])
                    )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.optionsObj[col.key + "map"][
                        _ctx.modalConfig.tableData[index][col.key]
                      ]), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(record[col.key]), 1))
                              ])
                            }
                          })
                        ]), 1032, ["rowSelection", "columns", "data-source", "rowKey", "scroll", "customRow"])
                      ], 4),
                      (_ctx.modalConfig.showPagination)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_a_pagination, {
                              size: "small",
                              onChange: _ctx.tablePageChange,
                              onShowSizeChange: _ctx.tablePageChange,
                              current: _ctx.modalConfig.pagination.current,
                              "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalConfig.pagination.current) = $event)),
                              pageSize: _ctx.modalConfig.pagination.pageSize,
                              "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalConfig.pagination.pageSize) = $event)),
                              total: _ctx.modalConfig.pagination.total,
                              pageSizeOptions: _ctx.modalConfig.pagination.pageSizeOptions,
                              "show-size-changer": "",
                              "show-total": _ctx.modalConfig.pagination.showTotal
                            }, null, 8, ["onChange", "onShowSizeChange", "current", "pageSize", "total", "pageSizeOptions", "show-total"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["visible", "title", "width"])
  ]))
}